import Mediator from 'gisw/Classes/Mediator';

export async function getUpdateInformation () {
  const updatesUrl = new URL('Documents/GetUpdates', location.href);
  updatesUrl.searchParams.append('entityName', Mediator.serverData.entityName);

  const res = await fetch(updatesUrl.toString(), { method: 'get' });

  if (!res.ok) {
    throw Error('Could not retrieve updates.');
  }

  /** @type {Array<{ name: string, updated: string; }>} */
  const data = await res.json();

  return data;
}
